/**
 * REEMPLAZA: frontend/src/App.js
 * Fase 3: agrega ruta /profile
 */
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProjectIDE from "./pages/ProjectIDE";
import Admin from "./pages/Admin";
import LandingEditor from "./pages/LandingEditor";
import Profile from "./pages/Profile";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ color:"#555", padding:"3rem", textAlign:"center" }}>Cargando…</div>;
  return user ? children : <Navigate to="/login" replace />;
}

function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/project/:id" element={<Protected><ProjectIDE /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/admin" element={<AdminGuard><Admin /></AdminGuard>} />
          <Route path="/admin/landing" element={<AdminGuard><LandingEditor /></AdminGuard>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
